module.exports.getDateString = function (date) {
  return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(
    2,
    "0"
  )}-${String(date.getDate()).padStart(2, "0")}`;
};

module.exports.getDateStringFromResintRegNo = function (date) {
  let year = 0;
  const month = date.substring(2, 4);
  const day = date.substring(4, 6);

  if (date.substring(6, 7) == 1 || date.substring(6, 7) == 2) {
    year = "19" + date.substring(0, 2);
  } else {
    year = "20" + date.substring(0, 2);
  }

  return `${year}-${month}-${day}`;
};

module.exports.getYearMonth = function (date) {
  return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(
    2,
    "0"
  )}`;
};
